import { useAtom } from 'jotai';
import { CuboidBase, CuboidState } from '../../types';
import { OutlinedIconButton } from './styles';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { TRANSPARENT_COLOR } from '@/constants';
import { ButtonGroup, Tooltip } from '@mui/material';

type Props<CuboidT extends CuboidBase> = {
  cuboidState: CuboidState<CuboidT>;
};

export const CuboidPointVisibilityControls = <CuboidT extends CuboidBase>({
  cuboidState,
}: Props<CuboidT>) => {
  const [transformMode, setTransformMode] = useAtom(cuboidState.isCuboidVisibilityBoxEnabled);

  const onClick = () => {
    setTransformMode((prev) => !prev);
  };

  const selected = transformMode;

  return (
    <ButtonGroup sx={{ paddingBottom: '10px' }}>
      <Tooltip title="Fade out">
        <OutlinedIconButton
          sx={{
            background: selected ? TRANSPARENT_COLOR : '#fff',
            '&:hover': {
              backgroundColor: 'transparent',
            },
            '&:focus': {
              backgroundColor: 'transparent',
            },
            '&.Mui-focusVisible': {
              backgroundColor: 'transparent',
            },
            transition: 'none',
          }}
          onClick={onClick}
        >
          <LightModeOutlinedIcon sx={{ color: selected ? '#fff' : TRANSPARENT_COLOR }} />
        </OutlinedIconButton>
      </Tooltip>
    </ButtonGroup>
  );
};
